/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

.value-row {
  @apply relative;
}

.value-row.content-left {
  @apply text-left;
}

.value-row.content-center {
  @apply text-center;
}

.value-row .value-row-top {
  @apply mb-[54px] relative;
}

.value-row .value-row-top .value-row-top-title {
  @apply w-fit h-auto font-poppins fs-4 font-semibold;
}

.value-row .value-row-top .value-row-top-description {
  @apply w-fit h-auto font-poppins fs-1 mt-20px;
}

.value-row .value-row-items {
  @apply w-full h-auto flex flex-row justify-start items-stretch flex-wrap md:flex-nowrap gap-x-[18px] sm:gap-x-[44px] md:gap-x-[50px] gap-y-[32px] relative;
}

.value-row .value-row-items .value-row-item {
  @apply w-full h-auto;
}

.value-row .value-row-items .value-row-item-content {
  @apply w-full h-auto block;
}

.value-row .value-row-items .value-row-item-content .value-row-item-content-title {
  @apply font-poppins fs-1 font-medium text-ui-gray-1 mt-12px;
}

.value-row .value-row-items .value-row-item-content .value-row-item-content-description {
  @apply font-poppins fs-0 text-ui-gray-3 mt-4px;
}

.value-row .value-row-items .value-row-item .value-row-icon {
  @apply w-[64px] h-[64px] object-cover;
}

.value-row .value-row-items .value-row-item .value-row-icon-masked {
  @apply w-[64px] h-[64px] bg-medium-blue;
  mask-size: cover;
  mask-position: center;
  mask-repeat: no-repeat;
}

.value-row .value-row-items .value-row-item .value-row-image {
  @apply w-full h-full max-h-[200px] object-cover rounded-[12px];
}

.value-row .value-row-items .value-row-item.value-row-item-3 .value-row-image {
  @apply max-h-[372px];
}

.value-row .value-row-items .value-row-item.value-row-item-4 .value-row-image {
  @apply max-h-[272px];
}

.value-row .value-row-items .value-row-item.value-row-item-5 .value-row-image {
  @apply max-h-[220px];
}

@media(max-width: 999px) {
  .value-row .value-row-items .value-row-item {
    max-width: calc(34% - 44px);
  }
}

@media(max-width: 767px) {
  .value-row .value-row-items .value-row-item {
    max-width: calc(50% - 18px);
  }
}

/* Animation fadeIn */
@keyframes fade-in {
  0% {
    opacity: 0.40;
  }
  100% {
    opacity: 0;
  }
}

.overlay0, .overlay1, .overlay2, .overlay3, .overlay4, .overlay5, .overlay6{
  @apply bg-white absolute w-full h-full top-0 left-0 z-10 opacity-50;
  /* filter: grayscale(100%); */
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;
  animation-duration: 200ms;
}

.value-row.animate .value-row-top .overlay0 {
  animation-name: fade-in;
  animation-delay: 0s;
}

.value-row.animate .overlay1{
    animation-name: fade-in;
    animation-delay: .1s;
  }
  
.value-row.animate .overlay2 {
  animation-name: fade-in;
  animation-delay: .15s;
}

.value-row.animate .overlay3 {
  animation-name: fade-in;
  animation-delay: 0.3s;
}

.value-row.animate .overlay4 {
  animation-name: fade-in;
  animation-delay: 0.45s;
}

.value-row.animate .overlay5 {
  animation-name: fade-in;
  animation-delay: 0.6s;
}

.value-row.animate .overlay6 {
  animation-name: fade-in;
  animation-delay: 0.75s;
}
